import { useMutation } from 'react-query';
import { useService } from '@core/inversify-react';

import { ISelectBoxRepo, SelectBoxRepoType } from '../repos';
import { queryClient } from '../../../index';

export type UseSelectBoxVariables = { id: number };

export const useSelectBox = () => {
  const selectBoxRepo = useService<ISelectBoxRepo>(SelectBoxRepoType);

  return useMutation<boolean, Error, UseSelectBoxVariables>(
    ['boxes', 'select'],
    async ({ id }) => {
      const result = await selectBoxRepo.execute(id);

      if (result.status === 200) {
        return true;
      } else {
        throw new Error(result.response);
      }
    },
    {
      onSettled: async () => {
        await queryClient.invalidateQueries(['boxes', 'me']);
      },
    },
  );
};
